import { render, staticRenderFns } from "./ClinicalSkillsLinkAccountModal.vue?vue&type=template&id=57989fdc&scoped=true"
import script from "./ClinicalSkillsLinkAccountModal.vue?vue&type=script&lang=js"
export * from "./ClinicalSkillsLinkAccountModal.vue?vue&type=script&lang=js"
import style0 from "./ClinicalSkillsLinkAccountModal.vue?vue&type=style&index=0&id=57989fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57989fdc",
  null
  
)

export default component.exports